import { createContext, useContext, useState } from "react";
import ActionPopup from "../components/ActionPopup";

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [popup, setPopup] = useState({
    open: false,
    type: "success",
    message: "",
  });

  const showPopup = (type, message) => {
    setPopup({
      open: true,
      type,
      message,
    });
  };

  const closePopup = () => {
    setPopup((prev) => ({ ...prev, open: false }));
  };

  return (
    <PopupContext.Provider value={{ showPopup }}>
      {children}

      {/* Global Popup */}
      <ActionPopup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={closePopup}
      />
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);
